export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";